module.exports = __webpack_public_path__ + "static/media/skills_assessment_intro.cf93511f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/skills_assessment_intro.svg
// module id = 1862
// module chunks = 0